import * as React from "react";
import BaseModal from "./base-modal";
import Notification from "../notification";
import {NotificationProps} from "../notification";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default class CardModal extends BaseModal<CardModalProps> {
    render() {
        const className = this.props.className;
        const id = this.props.id;
        const children = this.props.children;
        const footerClassName = "modal-card-foot field is-grouped is-grouped-right";
        const isActive = this.props.active;
        const loading = this.props.loading;
        const disabled = this.props.disabled;
        const notification = this.props.notification;
        const onClickCloseButton = this.props.onClickCloseButton;
        const onClickDeleteButton = this.props.onClickDeleteButton;
        const onClickFooterButton = this.props.onClickFooterButton;
        const onSubmit = this.props.onSubmit;
        const title = this.props.title;
        const type = this.props.type;
        const graph = this.props.graph;
        const showError = this.props.show;

        let footer = (
            <footer className={footerClassName}>
                <button
                    className={`button is-primary ${loading ? "is-loading" : ""}`}
                    type="submit"
                >
                    OK
                </button>
            </footer>
        );

        switch (type) {
            case CardModalType.ValidCancel:
                footer = (
                    <footer className={footerClassName}>
                        <button
                            id='validate'
                            className={`button is-primary ${loading ? "is-loading" : ""}`}
                            type="submit"
                            disabled={disabled ? disabled : false}
                        >
                            Valider
                        </button>
                        <button
                            className={`button ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(
                                this,
                                CardModalNotOkButton.Cancel
                            )}
                            type="button"
                        >
                            Annuler
                        </button>
                    </footer>
                );
                break;
            case CardModalType.ValidCancelDelete:
                footer = (
                    <footer className={footerClassName}>
                        <button
                            className={`button is-danger ${loading ? "is-loading" : ""}`}
                            onClick={onClickDeleteButton.bind(
                                this,
                                CardModalNotOkButton.Delete
                            )}
                            type="button"
                        >
                            Supprimer
                        </button>
                        <button
                            className={`button is-primary ${loading ? "is-loading" : ""}`}
                            type="submit"
                        >
                            Mettre à jour
                        </button>
                        <button
                            className={`button ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(
                                this,
                                CardModalNotOkButton.Cancel
                            )}
                            type="button"
                        >
                            Annuler
                        </button>
                    </footer>
                );
                break;
            case CardModalType.YesNo:
                footer = (
                    <footer className={footerClassName}>
                        <button
                            className={`button is-primary ${loading ? "is-loading" : ""}`}
                            type="submit"
                        >
                            Oui
                        </button>
                        <button
                            className={`button ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(this, CardModalNotOkButton.No)}
                            type="button"
                        >
                            Non
                        </button>
                    </footer>
                );
                break;
            case CardModalType.YesNoCancel:
                footer = (
                    <footer className={footerClassName}>
                        <button
                            className={`button is-primary ${loading ? "is-loading" : ""}`}
                            type="submit"
                        >
                            Oui
                        </button>
                        <button
                            className={`button ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(this, CardModalNotOkButton.No)}
                            type="button"
                        >
                            Non
                        </button>
                        <button
                            className={`button ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(
                                this,
                                CardModalNotOkButton.Cancel
                            )}
                            type="button"
                        >
                            Annuler
                        </button>
                    </footer>
                );
                break;
            case CardModalType.Switch:
                footer = (
                    <footer className={footerClassName}>
                        <button
                            className={`button is-primary ${loading ? "is-loading" : ""}`}
                            onClick={onClickFooterButton.bind(
                                this,
                                CardModalNotOkButton.Switch
                            )}
                        >
                            Changer vers la vue{" "}
                            {graph == "bar" ? "en Colonnes" : "en Camembert"}
                        </button>
                    </footer>
                );
                break;
        }

        return (
            <div
                id={id}
                className={`${className || ""} modal ${isActive ? "is-active" : ""}`}
            >
                <div className="modal-background" onClick={onClickCloseButton}/>
                <form
                    className={`modal-card ${this.props.isFluid ? " is-fluid" : ""}`}
                    method="POST"
                    onSubmit={onSubmit}
                >
                    <header className="modal-card-head">
                        <p className="modal-card-title">
                            {title}{" "}
                            {showError && (
                                <span style={{color: "orange", marginLeft: "18%"}}>
                  <FontAwesomeIcon icon="exclamation-triangle"/> Attention, le
                  budget annuel est différent du total prévu
                </span>
                            )}
                        </p>
                        <button
                            aria-label="close"
                            className="delete"
                            onClick={onClickCloseButton}
                            type="button"
                        />
                    </header>

                    <main
                        className={`modal-card-body ${
                            this.props.paddingLess ? "is-paddingless" : ""
                        }`}
                    >
                        {notification && (
                            <Notification
                                level={notification.level}
                                message={notification.message}
                                onClickCloseButton={this.props.onClickNotificationCloseButton}
                            />
                        )}
                        {children}
                    </main>
                    {footer}
                </form>
            </div>
        );
    }
}

export interface CardModalProps {
    id?: string;
    className?: string;
    loading?: boolean;
    notification?: NotificationProps;
    paddingLess?: boolean;
    title?: string;
    type?: CardModalType;
    graph?: string;
    show?: any;
    disabled?: boolean;

    onClickNotificationCloseButton?(event: React.SyntheticEvent<Element>): void;

    onClickDeleteButton?(
        button: CardModalNotOkButton,
        event: React.SyntheticEvent<Element>
    ): void;

    onClickFooterButton(
        button: CardModalNotOkButton,
        event: React.SyntheticEvent<Element>
    ): void;

    onSubmit(event: React.FormEvent<HTMLFormElement>): void;
}

export enum CardModalNotOkButton {
    Cancel,
    No,
    Delete,
    Switch,
}

export enum CardModalOkButton {
    Ok,
    Valid,
    Yes,
}

export enum CardModalType {
    Ok,
    ValidCancel,
    ValidCancelDelete,
    YesNo,
    YesNoCancel,
    Switch,
}



// WEBPACK FOOTER //
// ./src/component/modal/card-modal.tsx